import { getPageViewData } from './platform';
import { sendEventV2Once } from '@/utils/analytics';

export function sendPageViewEvent() {
    try {
        const { strings, numbers } = getPageViewData();
        sendEventV2Once('pageview', strings, numbers);
    } catch (err) {
        console.warn('Failed to send pageview event', err);
    }
}
